import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AttachmentCategory, ImageAttachment } from '@bonusly/common-action-input';
import { useToast } from '@bonusly/design-system';
import { useHttpClient } from '@bonusly/http-client';

export const useGenerateImageForAttachment = ({ onSettledCallback }: { onSettledCallback?: () => void }) => {
	const http = useHttpClient('v2');
	const toast = useToast();
	const { t } = useTranslation('recognition');

	const mutation = useMutation<ImageAttachment, Error, File>(
		async (file: File) => {
			const form = new FormData();
			form.append('file', file);

			const data = await http.post('/bonus_images', form);
			const image = data.data.result;

			return new ImageAttachment({
				category: AttachmentCategory.Image,
				alt_text: image.image_name,
				gif: image.image_path,
				mp4: image.image_path,
			});
		},
		{
			onSettled: onSettledCallback,
			onError: () => {
				toast({
					title: t('bonus_input.image.upload_error'),
					status: 'error',
				});
			},
		}
	);

	return {
		generateImageForAttachment: mutation.mutateAsync,
		isLoading: mutation.isLoading,
	};
};
